import { ProjectSelectors } from "@app/project/store";
import { initialConditionState } from "@app/project/store/clarehome.state";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CHConditionState } from "../rule.state";

const selectConditionState = createFeatureSelector<CHConditionState>("chCondition");

export const selectConditionsState = createSelector(
    selectConditionState,
    ProjectSelectors.getUuid,
    (state: CHConditionState, uuid: string) => (state?.uuid ? state : initialConditionState(uuid))
);

export const selectCondition = (conditionId: string) =>
    createSelector(selectConditionsState, conditionState => ({
        uuid: conditionState.uuid,
        callState: conditionState.callState,
        result: conditionState.result?.[conditionId] || null,
    }));
